import React from "react";
import TextArea from "@components/textArea";
import { useFormikContext } from "formik";
import { useSetDefaultValue } from "@hooks";

const name = "foreseeableChangesExplain";

export default function Explain({hidden}) {
  const { handleChange, handleBlur, values, errors, touched } = useFormikContext();
  useSetDefaultValue(name);

  const style = {
    resize: 'vertical',
    minHeight: '100px'
  };

  return (
    <>
      <TextArea
        title="Please explain how your circumstances are likely to change."
        maxLength="650"
        name={name}
        value={values[name]}
        onChange={handleChange}
        onBlur={handleBlur}
        errorMessage={touched[name] ? errors[name] : ""}
        tabIndex={hidden ? "-1" : undefined}
        style={style}
      />
    </>
  );
}
